import { Typography } from '@mui/material';
import type { Theme } from '@mui/system';
import type { ComponentProps } from 'react';
import { combineSx } from '@/utils/combineSx';

const labelStyle = {
  base: {
    fontWeight: 600,
    color: (theme: Theme) => theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: '0.025em',
  },
};

type LabelProps = ComponentProps<typeof Typography> & {
  label: string;
};

const Label = ({ label, sx, ...props }: LabelProps) => {
  return (
    <Typography
      sx={combineSx([labelStyle.base], sx)}
      fontSize='fontSizes.smallest'
      data-id='label'
      {...props}
    >
      {label}
    </Typography>
  );
};

export { Label };
